import { useLocation, useNavigate } from "react-router-dom";
import { Home, Search, FileText, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const appsPath = user ? (user.role === "employer" ? "/isveren?tab=applications" : user.role === "admin" ? "/adc" : "/panel?tab=applications") : "/giris";
  const profilePath = user ? (user.role === "employer" ? "/isveren" : user.role === "admin" ? "/adc" : "/panel") : "/giris";

  const items = [
    { key: "home", label: "Ana Sayfa", icon: Home, path: "/", match: (p) => p === "/" },
    { key: "jobs", label: "İş İlanları", icon: Search, path: "/ilanlar", match: (p) => p.startsWith("/ilan") },
    { key: "apps", label: "Başvurular", icon: FileText, path: appsPath, match: (p) => p.includes("applications") },
    { key: "profile", label: user ? "Profil" : "Giriş", icon: User, path: profilePath, match: (p) => ["/panel", "/isveren", "/giris", "/adc"].some((x) => p.startsWith(x)) && !p.includes("applications") },
  ];

  return (
    <nav data-testid="bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-slate-200 pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-4 h-16">
        {items.map((it) => {
          const active = it.match(pathname);
          const Icon = it.icon;
          return (
            <button key={it.key} data-testid={`bottomnav-${it.key}`} onClick={() => navigate(it.path)} className="flex flex-col items-center justify-center gap-0.5">
              <Icon size={21} className={active ? "text-blue-600" : "text-slate-400"} />
              <span className={`text-[10px] font-medium ${active ? "text-blue-600" : "text-slate-500"}`}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
